import lmsReducer from './reducer'
import rootSaga from "./sagas"
import {
  fetchApplications,
  fetchAudienceTypes,
  fetchCourseStandards,
  fetchFeatures,
  fetchIndustries,
  fetchOrganizationTypes,
  fetchObjectives,
} from './actions'

const getLmsModule = () => ({
  id: 'lms',
  reducerMap: {
    lms: lmsReducer,
  },
  sagas: [
    rootSaga,
  ],
  initialActions: [
    fetchApplications(),
    fetchAudienceTypes(),
    fetchCourseStandards(),
    fetchFeatures(),
    fetchIndustries(),
    fetchOrganizationTypes(),
    fetchObjectives(),
  ],
  finalActions: [],
})

export default getLmsModule
